<template>
  <div>

  </div>
</template>

<script>
  import g from '@/components/Global.vue'
  import GlobalConfig from '@/components/Global.config.vue'
  import bus from '@/assets/eventBus'
  export default {
    data() {
      return {
        url: g.SpreadOptionsQuoteServerMarket,
        typeGather: GlobalConfig.diffMessageType,       //请求订阅类型数据
        diffWs: null,
        diffData: [],

        socketTimer: null,
        reconnectTimer: null,
        closeSign: null,

        closeTimer1: null,
        closeTimer2: null,

        urlFlag: false,

      }
    },
    created() {
      bus.$on("haveBaseData", this.haveBaseData)
      if(this.url !== '') this.urlFlag = true
    },
    destorySocket() {
      bus.$off("haveBaseData", this.haveBaseData)
    },
    methods: {
      init() {
        if(this.diffWs) return
        let initialize = Object.values(this.typeGather.request)
        initialize = initialize.map(type => {
          return {
            messageType: type
          }
        })
        let push = Object.values(this.typeGather.push)
        push = push.map(type => {
          return {
            messageType: type, 
            messageData: {
              choseDate: this.expiryDate
            },
          }
        })
        let data = [...Object.values(initialize), ...Object.values(push)]
        this.socketDataPush(data)
      },
      reconnect() {
        this.destorySocket()
        this.init()
      },
      socketDataPush(datas) {
        let url = this.url
        this.diffWs = new WebSocket(url)
        let _this = this
        this.diffWs.onopen = function(e) {
          datas.forEach(data => {
            this.send(JSON.stringify(data))
          }) 
          _this.socketTimer = setInterval(() => {
            if(this.readyState !== 1) {
              return
            }
            this.send(JSON.stringify({messageType: "HEARTBEAT"}))
          }, 20000)
        }
        this.diffWs.onmessage = function(e) {
          let msg = JSON.parse(e.data)
          if(!msg.messageData || msg.messageData == 1) return
          _this.discernName(msg.messageType, msg.messageData)
        }
        this.diffWs.onerror = function(e) {
          if(_this.reconnectTimer) return
          _this.reconnectTimer = setTimeout(() => {
            _this.reconnect()
            _this.reconnectTimer = null
          }, 60000)  
        }
        this.diffWs.onclose = function(e) {
          if(_this.initialize) return       //主动关闭连接, 不重连
          if(_this.reconnectTimer) return
          if(_this.closeSign) {
             _this.closeTimer2 = setTimeout(() => {      //防抖, 在一秒钟之内关闭多次, 只执行一次
              _this.reconnect()
            }, 1000)
            return
          }
          _this.closeSign = true

          setTimeout(() => {      //防抖, 在一秒钟之内关闭多次, 只执行一次
            _this.closeSign = false
          }, 1000)

          _this.closeTimer1 = setTimeout(() => {
            _this.reconnect()
          }, 500)
        }
      },
      
      discernName(type, msg) {
        switch(type) {
          case 'PUSH_ARBITRAGE_QUOTE_INFO':
            this.groupPushData(msg)
            break;
            default:
        }
      },
      groupPushData(msg) {
        let idx = null
        this.diffData.forEach((item, index) => {
          if(item.arbitrageQuoteId === msg.arbitrageQuoteId && item.underlying === msg.underlying && item.callPut === msg.callPut) {
            this.diffData.splice(index, 1, msg)
            idx = index
          }
        })
        if(idx === null) {
          this.diffData.push(msg)
        }
        this.$emit("push:data", this.diffData)
      },
      destorySocket() {
        if(this.diffWs) {
          this.initialize = true      //主动关闭连接, 不重连
          this.diffWs.close()
          this.diffWs = null
        }
        if(this.socketTimer) {
          clearInterval(this.socketTimer)
          this.socketTimer = null
        }
        if(this.reconnectTimer) {
          clearTimeout(this.reconnectTimer)
          this.reconnectTimer = null
        }
      },

      cancelData() {
        return new Promise((reslove, reject) => {
          let cancel = Object.values(this.typeGather.cancel)
          cancel.forEach(messageType => this.diffWs.send(JSON.stringify({messageType})))
          this.destorySocket()
          this.clearData()
          reslove()
        })
      },
      clearData() {
        this.diffData = []
      },

      haveBaseData() {
        this.urlFlag = true
        if(!this.diffWs && this.expiryDate && this.urlFlag) {
          this.url = g.SpreadOptionsQuoteServerMarket
          this.init()
        }
      }
    },
    watch: {
      $route: {
        handler(to, from) {
          if (to.path == '/') {
            if(this.expiryDate) {     //第一次刚进入界面的时候没有到期日, 这里是用来切换界面再切换回来时请求
              this.init()
            }
          } else if(from.path === '/') {
            this.cancelData()
          }
        },
        immediate: true
      },
      expiryDate(newValue, oldValue) {      //第一次进入获取到到期日后和手动切换到期日时进行
        if(this.diffWs && oldValue && newValue !== oldValue) {
          this.cancelData().then(() => {
            this.init()
          })
        } 

        if(!this.diffWs && !oldValue && newValue && this.urlFlag) {
          this.url = g.SpreadOptionsQuoteServerMarket
          this.init()
        }
      },
    },
    props: ["expiryDate"]
  }
</script>

<style scoped>

</style>